module.exports = __webpack_public_path__ + "static/logo-81455bfd1ec3fc87ab07d6a85cb264d5.svg";